import React from 'react';
import PropTypes from 'prop-types';

const Chairs = ({ color = '#224251', ...props }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11.9933 22L12.0001 16.5454" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M17.3694 14.7269H19.1592V9.27234M17.3694 15.6365C17.3706 15.755 17.3483 15.8725 17.304 15.9824C17.2596 16.0922 17.194 16.1923 17.1109 16.2767C17.0278 16.3612 16.9288 16.4284 16.8196 16.4745C16.7105 16.5206 16.5933 16.5447 16.4748 16.5454H7.52588C7.4074 16.5446 7.29023 16.5204 7.18109 16.4743C7.07195 16.4282 6.97297 16.361 6.88982 16.2766C6.80667 16.1921 6.74098 16.0922 6.69651 15.9823C6.65204 15.8725 6.62966 15.755 6.63065 15.6365V14.2728C6.63065 13.7717 7.03156 13.3633 7.52588 13.3633C10.6077 12.7578 13.5907 12.7578 16.4748 13.3633C16.9699 13.3633 17.3694 13.7717 17.3694 14.2728V15.6365ZM17.3694 9.27234H20.949C20.949 8.27278 20.1444 7.45459 19.1592 7.45459C18.1753 7.45459 17.3694 8.27278 17.3694 9.27234Z"
      stroke={color}
      strokeLinejoin="round"
    />
    <path
      d="M6.63061 14.727H4.84082V9.27236M15.5796 13.1969V3.81843C15.5796 2.8141 14.7777 2 13.7898 2H10.2102C9.22223 2 8.4204 2.8141 8.4204 3.81843V13.2044M6.63061 9.27236H3.05103C3.05103 8.2728 3.85694 7.45461 4.84082 7.45461C5.82538 7.45461 6.63061 8.2728 6.63061 9.27236Z"
      stroke={color}
      strokeLinejoin="round"
    />
    <path d="M5.73608 22H18.2503" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.42041 4.72729H15.5796" stroke={color} strokeLinejoin="round" />
  </svg>
);

Chairs.propTypes = {
  color: PropTypes.string
};

export default Chairs;
